import React from "react";
const ProductPrice = (props) => {
    return React.createElement(React.Fragment, null);
};
export default ProductPrice;
